var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 20,
    viewBox: "0 0 32 20",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 19.5,
    rx: 1.75,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5,
    width: 31.5,
    x: 0.25,
    y: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 14.2497C15.0133 15.0813 13.7335 15.5833 12.335 15.5833C9.21421 15.5833 6.68436 13.0835 6.68436 9.99999C6.68436 6.9164 9.21421 4.41666 12.335 4.41666C13.7335 4.41666 15.0133 4.91867 16 5.75027C16.9867 4.91867 18.2665 4.41666 19.6651 4.41666C22.7858 4.41666 25.3156 6.9164 25.3156 9.99999C25.3156 13.0835 22.7858 15.5833 19.6651 15.5833C18.2665 15.5833 16.9867 15.0813 16 14.2497Z",
    fill: "#ED0006",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.0001 14.2497C17.2151 13.2256 17.9856 11.7017 17.9856 9.99999C17.9856 8.29827 17.2151 6.77436 16.0001 5.75027C16.9868 4.91867 18.2666 4.41666 19.6651 4.41666C22.7858 4.41666 25.3157 6.9164 25.3157 9.99999C25.3157 13.0835 22.7858 15.5833 19.6651 15.5833C18.2666 15.5833 16.9868 15.0813 16.0001 14.2497Z",
    fill: "#F9A000",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 14.2496C17.2151 13.2255 17.9856 11.7016 17.9856 9.99987C17.9856 8.29815 17.2151 6.77424 16 5.75015C14.785 6.77424 14.0145 8.29815 14.0145 9.99987C14.0145 11.7016 14.785 13.2255 16 14.2496Z",
    fill: "#FF5E00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc4);
export default __webpack_public_path__ + "static/media/ic4.1ed672ea456f128433b1bc843815540f.svg";
export { ForwardRef as ReactComponent };